import { routes as modelsRoutes } from "@/admin/pages/models/routes";
import { routes as manufacturersRoutes } from "@/admin/pages/manufacturers/routes";
import { routes as componentsRoutes } from "@/admin/pages/components/routes";
import { routes as equipmentRoutes } from "@/admin/pages/equipment/routes";
import { routes as commoditiesRoutes } from "@/admin/pages/commodities/routes";
import { routes as fleetsRoutes } from "@/admin/pages/fleets/routes";
import { routes as vehiclesRoutes } from "@/admin/pages/vehicles/routes";
import { routes as adminsRoutes } from "@/admin/pages/admins/routes";
import { routes as oauthApplicationsRoutes } from "@/admin/pages/oauth-applications/routes";
import { routes as maintenanceRoutes } from "@/admin/pages/maintenance/routes";
import { routes as usersRoutes } from "@/admin/pages/users/routes";
import { routes as supporterContributionsRoutes } from "@/admin/pages/supporter-contributions/routes";
import { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("@/admin/pages/index.vue"),
    meta: {
      title: "home",
      icon: "fa-duotone fa-home-alt",
      needsAuthentication: true,
      exact: true,
      mobileNav: 0,
    },
  },
  {
    path: "/models/",
    component: () => import("@/admin/pages/models.vue"),
    children: modelsRoutes,
    redirect: { name: modelsRoutes[0].name },
    meta: {
      title: "admin.models.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-starship",
      mobileNav: 1,
      access: ["models"],
    },
  },
  {
    path: "/components/",
    component: () => import("@/admin/pages/components.vue"),
    children: componentsRoutes,
    redirect: { name: componentsRoutes[0].name },
    meta: {
      title: "admin.components.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-flux-capacitor",
      access: ["components"],
    },
  },
  {
    path: "/equipment/",
    component: () => import("@/admin/pages/equipment.vue"),
    children: equipmentRoutes,
    redirect: { name: equipmentRoutes[0].name },
    meta: {
      title: "admin.equipment.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-gun",
      access: ["equipment"],
    },
  },
  {
    path: "/commodities/",
    component: () => import("@/admin/pages/commodities.vue"),
    children: commoditiesRoutes,
    redirect: { name: commoditiesRoutes[0].name },
    meta: {
      title: "admin.commodities.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-boxes-stacked",
      access: ["commodities"],
    },
  },
  {
    path: "/manufacturers/",
    component: () => import("@/admin/pages/manufacturers.vue"),
    children: manufacturersRoutes,
    redirect: { name: manufacturersRoutes[0].name },
    meta: {
      title: "admin.manufacturers.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-industry",
      access: ["manufacturers"],
    },
  },
  {
    path: "/images",
    name: "admin-images",
    component: () => import("@/admin/pages/images.vue"),
    meta: {
      title: "admin.images.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-images",
      access: ["images"],
    },
  },
  {
    path: "/vehicles/",
    component: () => import("@/admin/pages/vehicles.vue"),
    children: vehiclesRoutes,
    redirect: { name: vehiclesRoutes[0].name },
    meta: {
      title: "admin.vehicles.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-rocket",
      access: ["vehicles"],
    },
  },
  {
    path: "/fleets/",
    component: () => import("@/admin/pages/fleets.vue"),
    children: fleetsRoutes,
    redirect: { name: fleetsRoutes[0].name },
    meta: {
      title: "admin.fleets.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-users-class",
      mobileNav: 2,
      access: ["fleets"],
    },
  },
  {
    path: "/users",
    component: () => import("@/admin/pages/users.vue"),
    children: usersRoutes,
    redirect: { name: usersRoutes[0].name },
    meta: {
      title: "admin.users.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-users",
      mobileNav: 3,
      access: ["users"],
    },
  },
  {
    path: "/admins/",
    component: () => import("@/admin/pages/admins.vue"),
    children: adminsRoutes,
    redirect: { name: adminsRoutes[0].name },
    meta: {
      title: "admin.admins.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-user-group-crown",
      access: ["admins"],
    },
  },
  {
    path: "/supporter-contributions/",
    component: () => import("@/admin/pages/supporter-contributions.vue"),
    children: supporterContributionsRoutes,
    redirect: { name: supporterContributionsRoutes[0].name },
    meta: {
      title: "admin.supporterContributions.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-hand-holding-heart",
      access: ["supporters"],
    },
  },
  {
    path: "/oauth-applications/",
    component: () => import("@/admin/pages/oauth-applications.vue"),
    children: oauthApplicationsRoutes,
    redirect: { name: oauthApplicationsRoutes[0].name },
    meta: {
      title: "admin.oauthApplications.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-key",
      access: ["oauth_applications"],
    },
  },
  {
    path: "/maintenance",
    name: "admin-maintenance",
    component: () => import("@/admin/pages/maintenance.vue"),
    children: maintenanceRoutes,
    redirect: { name: maintenanceRoutes[0].name },
    meta: {
      title: "admin.maintenance.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-screwdriver-wrench",
      access: ["maintenance"],
    },
  },
  {
    path: "/notifications",
    name: "admin-notifications",
    component: () => import("@/admin/pages/notifications.vue"),
    meta: {
      title: "admin.notifications.index",
      needsAuthentication: true,
      icon: "fa-duotone fa-bell",
      nav: "hidden",
    },
  },
  {
    path: "/login/",
    name: "admin-login",
    component: () => import("@/admin/pages/login.vue"),
    meta: {
      title: "login",
      icon: "fa-light fa-sign-in",
      hideWhenAuthenticated: true,
      nav: "footer",
    },
  },
  {
    path: "/404/",
    name: "404",
    component: () => import("@/admin/pages/404.vue"),
    meta: {
      title: "notFound",
      backgroundImage: "bg-404",
      nav: "hidden",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/admin/pages/404.vue"),
    meta: {
      title: "notFound",
      backgroundImage: "bg-404",
      nav: "hidden",
    },
  },
];
